export const URL_UNFURL_QUERY_KEYS = {
  all: ['url-unfurl'] as const,
  detail: (url: string) => [...URL_UNFURL_QUERY_KEYS.all, url] as const,
} as const;
